import Phaser from 'phaser';
import { getTextStyle } from '../scripts/FontConfig.js';

export default class HelpScene extends Phaser.Scene {
  constructor() {
    super('HelpScene');
  }
 createSceneTransitionIn() {
    // Use Phaser's native camera fade in
    this.cameras.main.fadeIn(300, 0, 0, 0);
  }
   createSceneTransitionOut(callback) {
    // Use Phaser's native camera fade out
    this.cameras.main.fadeOut(300, 0, 0, 0);
    this.cameras.main.on('camerafadeoutcomplete', (camera) => {
      callback();
    });
  }

  create() {
    this.createSceneTransitionIn();
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;
    
    // Background
    // this.add.rectangle(width / 2, height / 2, width, height, 0x2c3e50);
    this.add.image(width / 2, height / 2, 'backgroundScreen').setOrigin(0.5);
   
    
    // Background
    this.add.rectangle(width / 2, height / 2, width, height, 0x2c3e50);
    
    // Title
    this.add.text(width / 2, 100, 'HELP', getTextStyle({
      fontSize: '48px',
      fill: '#ecf0f1',
      fontWeight: 'bold'
    })).setOrigin(0.5);
    
    // Placeholder content
    this.add.text(width / 2, height / 2, 'Help content will be added here.\n\nThis scene is ready for implementation.', getTextStyle({
      fontSize: '24px',
      fill: '#bdc3c7',
      align: 'center'
    })).setOrigin(0.5);
    
    // Back button
    const backButton = this.add.text(width / 2, height - 100, 'Terug naar menu', getTextStyle({
      fontSize: '24px',
      fill: '#3498db',
      fontWeight: 'bold'
    })).setOrigin(0.5);
    
    backButton.setInteractive({ useHandCursor: true });
    backButton.on('pointerover', () => {
      backButton.setStyle({ fill: '#5dade2' });
    });
    backButton.on('pointerout', () => {
      backButton.setStyle({ fill: '#3498db' });
    });
    backButton.on('pointerdown', () => {
      this.nextScene();
    });
    
    // ESC key to go back
    this.input.keyboard.on('keydown-ESC', () => {
      this.nextScene();
    });
  }

    nextScene() {
    this.createSceneTransitionOut(() => {
      this.scene.start('StartScene');
    });
  }
}